package com.hyperether.goodjob.scenes.jobs.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Card
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.Sp
import com.hyperether.goodjob.models.Job
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.assigned
import com.hyperether.goodjob.resources.employees
import com.hyperether.goodjob.resources.not_assigned
import com.hyperether.goodjob.resources.teams
import com.hyperether.goodjob.scenes.components.CircleWithInitial
import com.hyperether.goodjob.scenes.components.CircleWithInitialUser
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource

@Composable
fun JobDetailsAssigneesView(job: Job?) {
    val users = job?.assignees?.employees.orEmpty()
    val teams = job?.assignees?.teams.orEmpty()

    Card(
        modifier = Modifier
            .fillMaxWidth()
            .padding(start = Dp(16f), end = Dp(16f), top = Dp(16f)),
        shape = RoundedCornerShape(Dp(8f)),
        elevation = Dp(8f)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(Dp(16f))
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
            ) {
                Text(
                    fontSize = Sp(18f),
                    fontWeight = FontWeight.W700,
                    text = stringResource(Res.string.assigned),
                )
            }
            if (users.isEmpty() && teams.isEmpty()) {
                Text(
                    fontSize = Sp(14f),
                    text = stringResource(Res.string.not_assigned),
                    fontWeight = FontWeight.W400
                )
            } else {
                if (users.isNotEmpty()) {

                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Text(
                            fontSize = Sp(14f),
                            text = stringResource(Res.string.employees),
                            fontWeight = FontWeight.W500
                        )
                    }
                    users.forEach { user ->
                        Spacer(modifier = Modifier.height(Dp(8f)))
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            CircleWithInitialUser(user)
                            Spacer(modifier = Modifier.width(Dp(8f)))
                            Text(
                                fontSize = Sp(14f),
                                text = user?.getName().orEmpty(),
                                fontWeight = FontWeight.W500
                            )
                        }
                    }
                }

                Spacer(modifier = Modifier.height(Dp(8f)))
                if (teams.isNotEmpty()) {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Text(
                            fontSize = Sp(14f),
                            text = stringResource(Res.string.teams),
                            fontWeight = FontWeight.W500
                        )
                    }
                    teams.forEach { team ->
                        Spacer(modifier = Modifier.height(Dp(8f)))
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            CircleWithInitial(team?.name)
                            Spacer(modifier = Modifier.width(Dp(8f)))
                            Text(
                                fontSize = Sp(14f),
                                text = team?.name ?: "",
                                fontWeight = FontWeight.W500
                            )
                        }
                    }
                }
            }
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun JobDetailsAssigneesViewWeb(job: Job?) {
    val users = job?.assignees?.employees
    if (users?.isNotEmpty() == true) {
        Spacer(modifier = Modifier.height(8.toScaleDp()))

        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                fontSize = 18.toScaleSp(),
                text = stringResource(Res.string.employees),
                fontWeight = FontWeight.Bold,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }

        Spacer(modifier = Modifier.height(8.toScaleDp()))

        FlowRow(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(24.toScaleDp())
        ) {
            users.forEach { employee ->
                employee?.let {
                    Row(
                        modifier = Modifier,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        CircleWithInitial(name = it.getName(), size = 20.toScaleDp(), fontSize = 12)
                        Spacer(modifier = Modifier.width(8.toScaleDp()))
                        Text(
                            text = it.getName(),
                            fontSize = 16.toScaleSp(),
                            fontWeight = FontWeight.Bold,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                }
            }
        }
    }

    val teams = job?.assignees?.teams
    if (teams?.isNotEmpty() == true) {
        Spacer(modifier = Modifier.height(8.toScaleDp()))

        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Spacer(modifier = Modifier.height(8.toScaleDp()))

            Text(
                fontSize = 18.toScaleSp(),
                text = stringResource(Res.string.teams),
                fontWeight = FontWeight.Bold,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }

        teams.forEach { team ->
            Spacer(modifier = Modifier.height(8.toScaleDp()))
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically
            ) {
                team?.let {
                    CircleWithInitial(name = it.name)
                    Spacer(modifier = Modifier.width(8.toScaleDp()))
                    Text(
                        text = it.name ?: "",
                        fontSize = 16.toScaleSp(),
                        fontWeight = FontWeight.Bold,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                }
            }
        }
    }
}
